import { ConcurrentsTypes } from './types';

export const getCompanyData = (cnpj: string) => ({
  types: [
    ConcurrentsTypes.GET_COMPANY_REQUEST,
    ConcurrentsTypes.GET_COMPANY_SUCCESS,
    ConcurrentsTypes.GET_COMPANY_FAILURE,
  ],
  promise: (client: any) => client.get(`/get_company_data?cnpj=${cnpj}`),
});

export const getCompanyCeisPenalties = (cnpj: string) => ({
  types: [
    ConcurrentsTypes.GET_PENALTIES_REQUEST,
    ConcurrentsTypes.GET_PENALTIES_SUCCESS,
    ConcurrentsTypes.GET_PENALTIES_FAILURE,
  ],
  promise: (client: any) =>
    client.get('/get_company_penalties', {
      params: { cnpj },
    }),
});

export const getCompanyCertidoesApf = (cnpj: string) => ({
  types: [
    ConcurrentsTypes.GET_CERTIDOES_APF_REQUEST,
    ConcurrentsTypes.GET_CERTIDOES_APF_SUCCESS,
    ConcurrentsTypes.GET_CERTIDOES_APF_FAILURE,
  ],
  promise: (client: any) =>
    client.get('/get_company_certidoes_apf', {
      params: { cnpj },
    }),
});

export const getCompanyPenaltiesSp = (cnpj: string) => ({
  types: [
    ConcurrentsTypes.GET_CERTIDOES_SP_REQUEST,
    ConcurrentsTypes.GET_CERTIDOES_SP_SUCCESS,
    ConcurrentsTypes.GET_CERTIDOES_SP_FAILURE,
  ],
  promise: (client: any) =>
    client.get('/get_company_penalties_sp', {
      params: { cnpj },
    }),
});

export const getCompanyBiddingsActivities = (cnpj: string, page: number) => ({
  types: [
    ConcurrentsTypes.GET_FOLLOWUP_REQUEST,
    ConcurrentsTypes.GET_FOLLOWUP_SUCCESS,
    ConcurrentsTypes.GET_FOLLOWUP_FAILURE,
  ],
  promise: (client: any) => client.get(`/get_company_bidding_data.json?cnpj=${cnpj}&page=${page}`),
});

export const BiddingList = (params: object, page: number) => ({
  types: [
    ConcurrentsTypes.GET_BIDDINGS_REQUEST,
    ConcurrentsTypes.GET_BIDDINGS_SUCCESS,
    ConcurrentsTypes.GET_BIDDINGS_FAILURE,
  ],
  promise: (client: any) =>
    client.get(`/biddings_list?page=${page}`, {
      params,
    }),
});

export const Sanctions = (params: object, page: number) => ({
  types: [
    ConcurrentsTypes.GET_SANCTIONS_LIST_REQUEST,
    ConcurrentsTypes.GET_SANCTIONS_LIST_SUCCESS,
    ConcurrentsTypes.GET_SANCTIONS_LIST_FAILURE,
  ],
  promise: (client: any) =>
    client.get(`/sanctions_list?page=${page}`, {
      params,
    }),
});

export const getByMembership = (names: string[]) => ({
  types: [
    ConcurrentsTypes.GET_MEMBERSHIP_DATA_REQUEST,
    ConcurrentsTypes.GET_MEMBERSHIP_DATA_SUCCESS,
    ConcurrentsTypes.GET_MEMBERSHIP_DATA_FAILURE,
  ],
  promise: (client: any) =>
    client.post('/get_membership_data', {
      membership_names: names,
    }),
});
export const listMyBiddings = (cnpj: string) => ({
  types: [
    ConcurrentsTypes.ITENS_VENCIDOS_REQUEST,
    ConcurrentsTypes.ITENS_VENCIDOS_SUCCESS,
    ConcurrentsTypes.ITENS_VENCIDOS_FAILURE,
  ],
  promise: (client: any) => client.get(`/list_my_biddings/${cnpj}`),
});

export const ListStrategicAspects = (cnpj: string) => ({
  types: [
    ConcurrentsTypes.LIST_STRATEGIC_ASPECTS_REQUEST,
    ConcurrentsTypes.LIST_STRATEGIC_ASPECTS_SUCCESS,
    ConcurrentsTypes.LIST_STRATEGIC_ASPECTS_FAILURE,
  ],
  promise: (client: any) => client.get(`/strategic_aspects/${cnpj}`),
});

export const PARTICIPANTS_PER_PAGE = 5;

export const participants = (
  cnpj: string,
  pageVencidos = 1,
  pageNaoVencidos = 1,
  perPage: number = PARTICIPANTS_PER_PAGE,
) => ({
  types: [
    ConcurrentsTypes.PARTICIPACOES_RESUMO_REQUEST,
    ConcurrentsTypes.PARTICIPACOES_RESUMO_SUCCESS,
    ConcurrentsTypes.PARTICIPACOES_RESUMO_FAILURE,
  ],
  promise: (client: any) =>
    client.get(
      `/participants/${cnpj}?page_vencidos=${pageVencidos}&page_nao_vencidos=${pageNaoVencidos}&per_page=${perPage}`,
    ),
});
